import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44fdf2e2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=44fdf2e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLogo: require('/opt/yamal.ru/src/components/base/logo.vue').default,BaseHeaderSearch: require('/opt/yamal.ru/src/components/base/header/search.vue').default,BaseHeaderLangSwitcher: require('/opt/yamal.ru/src/components/base/header/lang-switcher.vue').default,RzIconBurger: require('/opt/yamal.ru/node_modules/razlet-ui/src/icons/icon-burger/index.vue').default,BaseHeaderDrawer: require('/opt/yamal.ru/src/components/base/header/drawer/index.vue').default})
